import React from 'react';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, onClose, title = "Success!", message = "Action completed successfully." }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="success-modal">
                <div className="success-icon-container">
                    <i className="fa-solid fa-check"></i>
                </div>
                <h3 className="success-title">{title}</h3>
                <p className="success-message">{message}</p>
                <button className="success-btn" onClick={onClose}>
                    Continue
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;
